module.exports = __webpack_public_path__ + "img/terroir-wavy-3-mobile.f6ba58a2.jpg";